import { Button, TextButton } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/modal/modal";
import type { ResultStep } from "../../../store/survey";
import { ResultBox } from "./result-box";

interface RemoveModalProps {
  survey?: ResultStep;
  onRemove: () => void;
  onClose: () => void;
}
export function RemoveModal({ survey, onRemove, onClose }: RemoveModalProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Modal show={Boolean(survey)} close={onClose} modalTitle={t("sureOnRemovePPData")} fitContent>
      {survey !== undefined && (
        <>
          <div className="font-normal text-xl text-black mb-1.25">{t("sureOnRemovePPData")}</div>
          <ResultBox survey={survey} />
          <div className="my-3 flex flex-col justify-center">
            <Button loading={false} type="submit" onClick={onRemove}>
              {t("button.delete")}
            </Button>
            <TextButton onClick={onClose}>{t("button.cancel")}</TextButton>
          </div>
        </>
      )}
    </Modal>
  );
}
